module.exports = __webpack_public_path__ + "static/media/koryu_00012.87cc535a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/koryu_00012.png
// module id = 234
// module chunks = 0